<template>
  <div
    class="RenderAuthAvatar relative"
    :class="{ 'overflow-x-hidden': !compact }"
  >
    <ClientOnly>
      <TAvatar
        :img-prop="imgProp"
        :size="compact ? 'sm' : 'md'"
        variant="image"
        :title="avatarTitle"
        :subtitle="avatarSubitle"
      />
      <AuthUnread v-if="compact" />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useLoginComposable } from '~/modules/auth/composables/useLoginComposable'
import type { TLazyimg_Props } from '~/modules/design-system/components/t-lazyimg/constants/types'

const { RenderAuthUserInstance } = useLoginComposable()

const props = defineProps({
  compact: {
    type: Boolean,
    default: false,
  },
})

const imgProp = computed(() => {
  const imgProp: TLazyimg_Props = {
    // @ts-ignore
    sources: { url: RenderAuthUserInstance?.value?.avatar },
    alt: RenderAuthUserInstance?.value?.name,
  }

  return imgProp
})

const avatarTitle = computed(() => {
  return props.compact ? '' : RenderAuthUserInstance?.value?.name
})

const avatarSubitle = computed(() => {
  return props.compact ? '' : RenderAuthUserInstance?.value?.mail
})
</script>
